var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 1.66406V4.9974M5.66667 1.66406V4.9974M1.5 8.33073H16.5M3.16667 3.33073H14.8333C15.7538 3.33073 16.5 4.07692 16.5 4.9974V16.6641C16.5 17.5845 15.7538 18.3307 14.8333 18.3307H3.16667C2.24619 18.3307 1.5 17.5845 1.5 16.6641V4.9974C1.5 4.07692 2.24619 3.33073 3.16667 3.33073Z",
    stroke: "#62636C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calenderIcon.8d2001dda6d8d98ca0c7497751d4c8f4.svg";
export { ForwardRef as ReactComponent };